import React from "react";
import ReactDOM from "react-dom/client";

// Bootstrap 5 is the base framework (resets, grid, form controls); the app's
// own dark-navy/gold design system sits on top via inline styles + the
// Tailwind-compatible utility layer below, which preserves the original
// prototype's layout classes exactly (see src/styles/utilities.css).
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/utilities.css";
import "./index.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
